<template>
  <v-row class="pa-5" v-if="doc">
    <v-col cols="3">
      <p class="blue--text headline mt-10">Strengths</p>
      <ul class="list--none">
        <li class="ma-1" v-for="(tag, index) in doc.strengths" :key="index">
          <span class="pr-2">{{ tag|sentence }}</span>
        </li>
      </ul>
    </v-col>
    <v-col cols="3">
      <p class="green--text headline mt-10">Weaknesses</p>
      <ul class="list--none">
        <li class="ma-1" v-for="(tag, index) in doc.weaknesses" :key="index">
          <span class="pr-2">{{ tag|sentence }}</span>
        </li>
      </ul>
    </v-col>
    <v-col cols="3">
      <p class="deep-orange--text headline mt-10">Opportunities</p>
      <ul class="list--none">
        <li class="ma-1" v-for="(tag, index) in doc.opportunities" :key="index">
          <span class="pr-2">{{ tag|sentence }}</span>
        </li>
      </ul>
    </v-col>
    <v-col cols="3">
      <p class="pink--text headline mt-10">Threats</p>
      <ul class="list--none">
        <li class="ma-1" v-for="(tag, index) in doc.threats" :key="index">
          <span class="pr-2">{{ tag|sentence }}</span>
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsSwotSummary",
  data() {
    return {
      doc: null,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.swotExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", "shared");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
